import { createSelector } from '@ngrx/store';
import { getOrdersAndProductsComponentsState } from '@ordersnproducts/modules/shared/reducers';

export const getPaymentTerms = createSelector(
  getOrdersAndProductsComponentsState,
  (state) => state.paymentTermsState.paymentTerms,
);
